import createIcon from '../../createIcon';

/**
 * @component @name SignalWifiStatusbar4Bar
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMy41QzcuMzEgMy41IDMuMDcgNS40IDAgOC40OEwxMiAyMC41TDI0IDguNDhDMjAuOTMgNS40IDE2LjY5IDMuNSAxMiAzLjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SignalWifiStatusbar4Bar = createIcon('SignalWifiStatusbar4Bar', [
  [
    'path',
    {
      d: 'M12 3.5C7.31 3.5 3.07 5.4 0 8.48L12 20.5L24 8.48C20.93 5.4 16.69 3.5 12 3.5Z',
      key: 'ibkv4u',
    },
  ],
]);

export default SignalWifiStatusbar4Bar;
